/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { ITableRowData } from './table-row.data';
import { ITableRowProps } from './table-row.props.autogenerated';

export interface ITableRowViewProps extends ITableRowProps<ITableRowData> {

}

/**
 *
 * TableRow component
 * @extends {React.PureComponent<ITableRowProps<ITableRowData>>}
 */
class TableRow extends React.PureComponent<ITableRowProps<ITableRowData>> {
    public render(): JSX.Element | null {

        const viewProps = {
            ...this.props,
            cellItems: {
                moduleProps: this.props
            }
        };
        return this.props.renderView(viewProps);
    }
}

export default TableRow;
